var React = require('react');

function AlgorandInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26 26.0295H22.5508L20.3108 17.6969L15.4947 26.0305H11.6441L19.0879 13.131L17.8898 8.65271L7.85249 26.0332H4L16.7204 4H20.093L21.5697 9.47416H25.0493L22.6736 13.6054L26 26.0295Z","fill":"white"}));
}

AlgorandInline.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = AlgorandInline;

AlgorandInline.default = AlgorandInline;
